module.exports = __webpack_public_path__ + "f4c46b5d.svg";